import { Component } from '@angular/core';

@Component({
    templateUrl: './bidding-help.component.html',
    standalone: false
})
export class BiddingHelpComponent{}

